import { Routes } from '@angular/router';
import { authGuard, roleGuard, excludeRoleGuard } from './core/auth/auth.guard';
import { stationContextGuard } from './core/guards/station-context.guard';
import { UserRole } from './core/models';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login').then((m) => m.Login),
  },
  {
    path: '',
    loadComponent: () => import('./shared/layout/layout').then((m) => m.Layout),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'route-stations', pathMatch: 'full' },
      {
        path: 'route-stations',
        title: 'Stationen',
        loadComponent: () =>
          import('./features/route-stations/route-stations').then((m) => m.RouteStations),
      },
      {
        path: 'radar-list',
        title: 'Radar Auswahl',
        canActivate: [stationContextGuard, roleGuard(UserRole.Admin)],
        loadComponent: () =>
          import('./features/radar-list/radar-list').then((m) => m.RadarList),
      },
      {
        path: 'display-list',
        title: 'Displays',
        canActivate: [stationContextGuard],
        loadComponent: () =>
          import('./features/display-list/display-list').then((m) => m.DisplayList),
      },
      {
        path: 'various',
        title: 'Peripherie',
        canActivate: [stationContextGuard],
        loadComponent: () =>
          import('./features/various/various').then((m) => m.Various),
      },
      {
        path: 'overview',
        title: 'Übersicht',
        canActivate: [stationContextGuard],
        loadComponent: () =>
          import('./features/overview-functions/overview-functions').then(
            (m) => m.OverviewFunctions
          ),
      },
      {
        path: 'sensor/choice/:id',
        title: 'Sensor Auswahl',
        canActivate: [stationContextGuard],
        loadComponent: () =>
          import('./features/sensor-choice/sensor-choice').then((m) => m.SensorChoice),
      },
      {
        path: 'sensor/live/:id/:dekanal',
        title: 'Sensor LiveData',
        canActivate: [stationContextGuard],
        loadComponent: () =>
          import('./features/sensor-live/sensor-live').then((m) => m.SensorLive),
      },
      {
        path: 'sensor/average/:id/:dekanal',
        title: 'Sensor AverageData',
        canActivate: [stationContextGuard],
        loadComponent: () =>
          import('./features/sensor-average/sensor-average').then((m) => m.SensorAverage),
      },
      {
        path: 'sensor/config',
        title: 'Sensor Konfiguration',
        canActivate: [stationContextGuard, roleGuard(UserRole.Admin)],
        loadComponent: () =>
          import('./features/sensor-config/sensor-config').then((m) => m.SensorConfig),
      },
      {
        path: 'multiple-sensors',
        title: 'Sensoren',
        canActivate: [stationContextGuard],
        loadComponent: () =>
          import('./features/multiple-sensors/multiple-sensors').then(
            (m) => m.MultipleSensors
          ),
      },
      {
        path: 'one-click-config',
        title: 'One-Click Konfiguration',
        canActivate: [stationContextGuard, roleGuard(UserRole.Admin)],
        loadComponent: () =>
          import('./features/one-click-config/one-click-config').then(
            (m) => m.OneClickConfig
          ),
      },
      {
        path: 'click-config',
        title: 'Konfiguration',
        canActivate: [stationContextGuard, roleGuard(UserRole.Admin)],
        loadComponent: () =>
          import('./features/click-config/click-config').then((m) => m.ClickConfig),
      },
      {
        path: 'test-station',
        title: 'Testbereich',
        canActivate: [stationContextGuard, excludeRoleGuard(UserRole.Streetworker)],
        loadComponent: () =>
          import('./features/test-station/test-station').then((m) => m.TestStation),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
